<template>
  <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
    <div>
      <p class="text-xl font-bold text-center mb-7 pc:text-4xl pc:mb-11">
        {{ classPayment.classPaymentData.classPaymentDataList.memberName }} 님의 기존 수강 내역입니다.
      </p>
      <div>
        <ul class="flex flex-col border-t border-b border-solid pc:hidden border-neutral-950 mb-14">
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">수강기간</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.classPaymentData.classPaymentDataList.sdate }} ~ {{ classPayment.classPaymentData.classPaymentDataList.edate }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">수업유형</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.lecTypeText() }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">언어</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.languageText() }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">과정</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.classPaymentData.classPaymentDataList.sugangAdult }} {{ classPayment.classPaymentData.classPaymentDataList.sugangClassName }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">교재</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.classPaymentData.classPaymentDataList.title }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">수업 횟수</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.lecCountText() }}</p>
          </li>
          <li class="flex border-b border-solid border-neutral-200">
            <p class="text-sm font-bold py-7 flex-none w-[90px] bg-neutral-50 text-center">수업 시간</p>
            <p class="pl-10 text-sm font-medium py-7 grow">{{ classPayment.lecTimeText() }}</p>
          </li>
        </ul>
        <table class="hidden overflow-hidden border-t border-b border-solid pc:table mb-11">
          <thead class="bg-neutral-50">
            <tr class="border-b border-solid border-neutral-200">
              <th class="text-lg border-r border-solid p-7 border-neutral-200">수강기간</th>
              <th class="text-lg border-r border-solid p-7 border-neutral-200">수업유형</th>
              <th class="text-lg border-r border-solid p-7 border-neutral-200">언어</th>
              <th class="text-lg border-r border-solid p-7 border-neutral-200">과정</th>
              <th class="text-lg border-r border-solid p-7 border-neutral-200">교재</th>
              <th class="text-lg border-r border-solid p-7 border-neutral-200">수업 횟수</th>
              <th class="text-lg p-7">수업 시간</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b border-solid border-neutral-200 last-of-type:border-none">
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.classPaymentData.classPaymentDataList.sdate }}<br />~ {{ classPayment.classPaymentData.classPaymentDataList.edate }}</p>
              </td>
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.lecTypeText() }}</p>
              </td>
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.languageText() }}</p>
              </td>
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.classPaymentData.classPaymentDataList.sugangAdult }} {{ classPayment.classPaymentData.classPaymentDataList.sugangClassName }}</p>
              </td>
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.classPaymentData.classPaymentDataList.title }}</p>
              </td>
              <td class="px-2.5 py-3.5 border-r border-solid border-neutral-200">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.lecCountText() }}</p>
              </td>
              <td class="px-2.5 py-3.5">
                <p class="text-lg font-medium text-neutral-950">{{ classPayment.lecTimeText() }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="grid grid-cols-2 gap-2.5 pc:gap-5 pc:max-w-md mx-auto max-w-xs mb-10">
        <li
          class="flex items-center justify-center border border-solid rounded cursor-pointer border-neutral-500"
          @click="classPayment.getRegisterCheckCencle"
        >
          <p class="py-4 text-sm font-bold text-center text-neutral-500 pc:text-xl pc:py-6">신규 신청하기</p>
        </li>

        <li class="flex items-center justify-center bg-orange-500 rounded cursor-pointer" @click="classPayment.onClassApplyNext">
          <p class="py-4 text-sm font-bold text-center text-white pc:text-xl pc:py-6">재수강 신청하기</p>
        </li>
      </ul>

      <div class="flex justify-center">
        <p class="text-lg font-medium">
          신규 신청하기 : 과정을 처음 신청하시거나 과정/교재를 변경하는 경우
          <br />
          * 현재 수업 중이시더라도 강사/과정/교재를 변경하고자 하실 경우 '신규 신청하기'로 해주세요.
          <br />
          <br />
          재수강 신청하기 : 현재 진행중인 과정 (수업스케줄, 강사, 교재)으로 재수강 신청이 됩니다.
        </p>
      </div>

      <!-- 성인 -->
      <div v-if="classPayment.classPaymentData.classPaymentDataList.sugangAdult === '성인'" class="pt-16">
        <img src="@/assets/images/enrolment/foeverClass-adult.png" />
      </div>

      <!-- 주니어 -->
      <div v-if="classPayment.classPaymentData.classPaymentDataList.sugangAdult === '주니어'" class="pt-16">
        <img src="@/assets/images/enrolment/foeverClass-junior.png" />
      </div>
    </div>
  </section>
</template>
<script>
import { reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";
export default {
  components: {},

  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain; // store 에 저장된 idxLeSiteMain 값

    const classPayment = reactive({
      classPaymentData: {
        classPaymentDataList: [], // 결제 리스트
        idxLeSiteMain: idxLeSiteMain,
        idxLeSugangPayInfo: route.query.idxLeSugangPayInfo, // 수강결제정보
        idxInfoSugangOneLevel: null, // 재수강으로 신청할 1:1 수업 (없으면 null)
        isMobilePc: "", // 모바일 PC 구분
      },

      // 마지막 수강 내역 확인 함수
      getLast() {
        const params = {
          idxLeSiteMain: idxLeSiteMain,
        };
        axios.get(`/user/sugang/class/last`, { params }).then(function (res) {
          if (res.data.success === true) {
            classPayment.classPaymentData.classPaymentDataList = res.data.data.userSugangPayInfo;

            console.log(res.data.data.idxInfoSugangOneLevel);

            classPayment.classPaymentData.idxInfoSugangOneLevel = res.data.data.idxInfoSugangOneLevel;

            classPayment.classPaymentData.isMobilePc = res.data.data.isMobilePc;
          } else {
            alert(res.data.message);
          }
        });
      },

      // CTM 수업유형 코드 → 표시명
      lecTypeText() {
        const lecType = classPayment.classPaymentData.classPaymentDataList.lecType;
        const names = { V: "PC 화상", P: "전화", M: "모바일 화상", G: "그룹 화상" };
        return lecType ? `1:1 ${names[lecType] ?? lecType}` : "";
      },

      // CTM 언어 코드 → 표시명 (없으면 신청 당시 언어)
      languageText() {
        const { language, sugangLang } = classPayment.classPaymentData.classPaymentDataList;
        const names = {
          "English(US)": "영어(원어민)",
          "English(Philippines)": "영어(필리핀)",
          Chinese: "중국어",
          Japanese: "일본어",
        };
        return names[language] ?? language ?? sugangLang ?? "";
      },

      // 수업요일 7자리(일~토) → "월, 수"
      lecDayText() {
        const lecDay = classPayment.classPaymentData.classPaymentDataList.lecDayCtm ?? "";
        return ["일", "월", "화", "수", "목", "금", "토"].filter((_, i) => lecDay.charAt(i) === "1").join(", ");
      },

      lecCountText() {
        const { lecNum, lecMin, lecDayCtm } = classPayment.classPaymentData.classPaymentDataList;
        if (!lecNum || !lecMin) return "";
        const perWeek = (lecDayCtm ?? "").split("").filter((day) => day === "1").length;
        return `총 ${lecNum}회 / 주 ${perWeek}회 ${lecMin}분`;
      },

      lecTimeText() {
        const { stime, etime } = classPayment.classPaymentData.classPaymentDataList;
        if (!stime) return "";
        return `${classPayment.lecDayText()} ${stime} ~ ${etime ?? ""}`;
      },

      // 기존수강신청 내역 날리고 처음부터 신청 하기
      getRegisterCheckCencle() {
        router.push({ path: "/enrolment/newEnrolmentClass" });
      },

      // 기존에 신청 했던 동일한 수업 신청 함수
      onClassApplyNext() {
        if (!classPayment.classPaymentData.idxInfoSugangOneLevel) {
          alert("신청 가능한 재수강 수업이 없습니다.");
          return;
        }

        if (!confirm("재수강 신청하시겠습니까?")) {
          return;
        }

        const idxLeSugangOneLevel = classPayment.classPaymentData.idxInfoSugangOneLevel?.idxLeSugangOneLevel ?? "";
        const idxLeSugangOneTimeInfo = classPayment.classPaymentData.idxInfoSugangOneLevel?.idxLeSugangOneTimeInfo ?? "";
        const isBookBuy = classPayment.classPaymentData.classPaymentDataList?.isBookBuy ?? "";
        const isLevelTest = classPayment.classPaymentData.classPaymentDataList?.isLevelTest ?? "";
        const isMobilePc = classPayment.classPaymentData.isMobilePc ?? "";
        const sugangHopeTime1 = classPayment.classPaymentData.classPaymentDataList?.sugangHopeTime1 ?? "";
        const sugangHopeTime2 = classPayment.classPaymentData.classPaymentDataList?.sugangHopeTime2 ?? "";

        const params = {
          idxLeSugangOneLevel,
          idxLeSugangOneTimeInfo,
          isBookBuy,
          isLevelTest,
          isMobilePc,
          sugangHopeTime1,
          sugangHopeTime2,
          isRetake: "Y",
        };

        axios.post(`/user/sugang/class/registerOne`, params).then(function (res) {
          if (res.data.success === true) {
            const idxLeSugangPayInfo = res.data.data.idxLeSugangPayInfo;
            router.push({
              path: `/enrolment/checkDetail`,
              query: {
                idxLeSugangPayInfo: idxLeSugangPayInfo,
                isRenew: "Y",
              },
            });
          } else {
            alert(res.data.message);
          }
        });
      },
    });
    onMounted(() => {
      classPayment.getLast();
    });

    return {
      classPayment,
      idxLeSiteMain,
    };
  },
};
</script>
<style></style>
